<template>
  <div class="w-100">
    <div class="container-box mx-auto">
      <p class="manufa-title">
        All Manufacturer:<span class="text-active-color">( A-z )</span>
      </p>
      <!--  A-z -->
      <div class="w-100 A-z-box d-flex justify-content-around">
        <span :class="`Az-item ${active === item.key?'Az-item-active':''}`" v-for="item in AzItems" :key="item.key" @click="scrollToSection(item.key)">{{item.key}}</span>
      </div>

      <!-- manufa -->
      <div class="w-100 ">
        <div v-for="(item,index) in AzItems" :key="item.key" class="manufa-list-box d-flex">
          <div :id="item.key" :class="`manufa-list-left ${active === item.key?'text-active-color':''}`">{{item.key}}</div>
          <div class="manufa-list-right d-flex flex-wrap w-100 pt-2 pb-2">
            <b-link class="manufa-list-right-item one-line"
                    :key="a.id" v-for="a in item.options"
                    @click="pushProItem(a.id)"
            > {{a.manufactName}}<span class="main-text-color">({{a.count}})</span></b-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getAction} from "@api/manage";
import {mapGetters} from "vuex";

export default {
  name: "manufacturer",
  data(){
    return{
      AzItems:[],
      active:"0-9"
    }
  },
  created() {
    this.init();
  },
  mounted() {
    // 监听页面滚动事件
    // window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    // 在组件销毁前移除滚动事件监听
    // window.removeEventListener('scroll', this.handleScroll);
  },
  computed:{
    ...mapGetters(['manufacturerList'])
  },
  methods:{
    async init() {
      this.initAzItems();
      this.getList();

    },
    initAzItems(){
      // this.AzItems.push("0-9")
      let arr = []
      arr.push("0-9");
      for (let i = 0; i < 26; i++) {
        let code = String.fromCharCode(65+i);
        arr.push(code);
      }
      /*arr.forEach(item => {
        let list = this.options.filter(a => {
          if(item === '0-9'){
            return regPos.test(a.manufactName.trim().charAt(0));
          }
          return item.toUpperCase() === a.manufactName.trim().charAt(0).toUpperCase();
        })
        this.AzItems.push({key:item,options:list})
      })*/

      arr.forEach(item => {
        /*let list = this.options.filter(a => {
          if(item === '0-9'){
            return regPos.test(a.manufactName.trim().charAt(0));
          }
          return item.toUpperCase() === a.manufactName.trim().charAt(0).toUpperCase();
        })*/
        this.AzItems.push({key:item,options:[]})
      })
    },
    async getList() {
      let regPos = /^(0-9)+.?(0-9)*$/;
      this.AzItems.forEach(item => {
        item.options = this.manufacturerList.filter(a => {
          if(item.key === '0-9'){
            return regPos.test(a.manufactName.trim().charAt(0));
          }
          return item.key.toUpperCase() === a.manufactName.trim().charAt(0).toUpperCase();
        })
      })
      /*await getAction("/front/mallManufacturer/getList").then(res => {
        if (res.success) {

        }
      })*/
    },
    scrollToSection(sectionId){
      this.active = sectionId;
      // 滚动到指定锚点位置
      const sectionElement = document.getElementById(sectionId);
      if (sectionElement) {
        window.scrollTo({
          top: sectionElement.offsetTop - 200,
          behavior: 'smooth', // 添加滚动效果
        });
      }
    },
    handleScroll() {
      // 获取当前滚动位置
      const scrollPosition = window.scrollY || document.documentElement.scrollTop;

      // 遍历锚点，判断哪个应该被选中
      for (const section of this.AzItems) {
        const sectionElement = document.getElementById(section);
        if (sectionElement) {
          const sectionTop = sectionElement.offsetTop;
          const sectionBottom = sectionTop + sectionElement.offsetHeight;

          if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
            // 当前滚动位置在锚点区域内
            this.active = section;
            break;
          }
        }
      }
    },
    pushProItem(id){
      this.$router.push({ path: '/productItem/manufa', query: { manufacturerId:id } });
    }
  }
}
</script>



<style>
.manufa-list-right-item{
  flex-basis: calc(25% - 10px); /* 10px 是项目之间的间距，您可以根据需要调整 */
  /* 添加其他样式，如边框、内边距等 */
  margin: 5px; /* 项目之间的间距 */
  &:hover{
    color: var(--secondary-color)
  }
}
.manufa-list-box{
  min-height: 74px;
  border-top: 1px solid #e7e7e7;
}
.manufa-list-left{
  width: 63px;
  line-height: 63px;
  text-align: center;
}
.Az-item-active{
  background: rgba(226,102,20,.1);
  color: #E26614;
}
.Az-item{
  width: 40px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  border-radius: 6px;
  cursor: pointer;
}
.manufa-title{
  line-height: 33px;
  margin-bottom: 20px;
  color: var(--main-text-color);
  font-size: 15px;
  font-weight: 600;
}
.A-z-box{
  border-top: 1px solid #ccced4;
  border-bottom: 1px solid #ccced4;
  margin-top: 10px;
}
</style>
